var styles = {"ellipsis":"navkit__BusinessunitDropdownItem__ellipsis","info":"navkit__BusinessunitDropdownItem__info","changeBusinessUnit":"navkit__BusinessunitDropdownItem__changeBusinessUnit"};

export { styles as default };
